// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Setting_container__z07eX {
    position: absolute;
    margin: auto;
    bottom: 2px;
    height: fit-content;
    right: 10px;
    width: 150px;
    text-align: center;
}

.Setting_tooltip__Eusey{
    float: right !important;
    margin-top: 15px;
}

.Setting_setBtn__Tnv-0{
    float: right !important;
}`, "",{"version":3,"sources":["webpack://./src/components/settings/Setting.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B","sourcesContent":[".container {\n    position: absolute;\n    margin: auto;\n    bottom: 2px;\n    height: fit-content;\n    right: 10px;\n    width: 150px;\n    text-align: center;\n}\n\n.tooltip{\n    float: right !important;\n    margin-top: 15px;\n}\n\n.setBtn{\n    float: right !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Setting_container__z07eX`,
	"tooltip": `Setting_tooltip__Eusey`,
	"setBtn": `Setting_setBtn__Tnv-0`
};
export default ___CSS_LOADER_EXPORT___;
